import styled from 'styled-components';

export const FrameworkGrid = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;
